// extracted by mini-css-extract-plugin
export default {"skill":"SkillsBlock_skill__QhOCe","removable":"SkillsBlock_removable__oNcE1","removeButton":"SkillsBlock_removeButton__VTuIX","dark":"SkillsBlock_dark__-APVi"};